import {useNavigate} from 'react-router-dom';
import {useState, useEffect, useContext} from 'react';
import Instructions from '../../baseElements/Instructions';
import axios from 'axios';
import TopBar from "../../baseElements/TopBar";
import WordCard from "../../baseElements/WordCard";
import {activity_palettes} from "../../themes";
import ConfirmButton from "../../baseElements/ConfirmButton";
import SadFeedback from "../../baseElements/SadFeedback";
import HappyFeedback from "../../baseElements/HappyFeedback";
import AnimationOverlay from "../../baseElements/AnimationOverlay";

import '../../css/GeneralActivitiesCSS/GeneralActivityDesktop.css'
import '../../css/GeneralActivitiesCSS/GeneralActivityTablet.css'
import '../../css/GeneralActivitiesCSS/GeneralActivityPhone.css'
import {AppContext} from "../../AppContext";
import {checkActivityStatus, delay, generateUrl, getExerciseFromDB, getLog, randomizeWords, redirectToExercise, updateCurrentLog} from "../../ActivityManager";
import NextExerciseButton from "../../baseElements/NextExerciseButton";
import Spinner from "react-bootstrap/Spinner";
const randomNumber = Math.floor(Math.random() * 12) + 1;
const wallBackground = require(`../../assets/exercises/muro-${randomNumber}.png`);

axios.defaults.withCredentials = true;

const BACKGROUND_STYLE = activity_palettes.green.primary;
const INSTRUCTION_TEXT = "Aiutami ad abbattere il muro! Trova le coppie di parole che hanno qualcosa in comune e selezionale per distruggere i mattoni.";

function BaseDerivativeWall() {
    
    const {activityList, setActivityList, currentActivity} = useContext(AppContext);
    
    const navigate = useNavigate();
    const [, setIsMdOrLess] = useState(window.innerWidth <= 768);
    
    const [words, setWords] = useState([]);
    const [maxSteps, setMaxSteps] = useState(0);
    const [stepInfo, setStepInfo] = useState(0);
    const [levelInfo, setLevelInfo] = useState(0);
    const [instructionAudioUrl, setInstructionAudioUrl] = useState('');
    const [loading, setLoading] = useState(true);
    
    const [clickedWordsId, setClickedWordsId] = useState([]);
    const [confirmedWords, setConfirmedWords] = useState([]);
    const [feedback, setFeedback] = useState('');
    const [correctWords, setCorrectWords] = useState([]);
    const [errorWords, setErrorWords] = useState([]);
    const [isAnimating, setIsAnimating] = useState(false);
    const [flowButtons, setFlowButtons] = useState({confirm: true, nextExercise: false});
    const [exerciseLog, setExerciseLog] = useState({exercise_id: 0, exercise_type: '', progress: 0, actions: []});
    
    const exerciseId = activityList[0][0];
    const exerciseType = activityList[0][1];
    
    function updateButtonFlow(showConfirm, showNextExercise) {
        setFlowButtons({confirm: showConfirm, nextExercise: showNextExercise});
    }
    
    function resetStates() {
        setWords([]);
        setMaxSteps(0);
        setStepInfo(0);
        setClickedWordsId([]);
        setConfirmedWords([]);
        setFeedback('');
        setCorrectWords([]);
        setErrorWords([]);
        setIsAnimating(false);
        updateButtonFlow(true, false);
        setLoading(true);
        setExerciseLog({exercise_id: 0, exercise_type: '', progress: 0, actions: []});
    }
    
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        
        window.onpopstate = (event) => {
            event.preventDefault();
            navigate('/home'); // Navigate directly to /home
        };
        
        return () => {
            window.onpopstate = null;
        };
    }, [navigate]);
    
    const handleResize = () => {
        setIsMdOrLess(window.innerWidth < 768);
    };
    
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    useEffect(() => {
        resetStates();
        loadExercise().then(
            () => {
                syncExerciseWithDB().then(() => setLoading(false));
            }
        );
    }, [navigate]);
    
    async function loadExercise() {
        await delay(750);
        getExerciseFromDB(activityList)
            .then((response) => {
                if (response.success) {
                    const json = JSON.parse(JSON.stringify(response.data[4]));
                    const level = JSON.parse(JSON.stringify(response.data[3]));
                    let wordsTemporary = [];
                    json.coppie_base_derivato.parts.forEach((activity) => {
                        wordsTemporary.push({id: activity.wordId, name: activity.wordName, couple_id: activity.coupleId});
                    });
                    
                    generateUrl("coppie base derivato").then((url) => {
                        setInstructionAudioUrl(url)
                    });
                    
                    wordsTemporary = randomizeWords(wordsTemporary);
                    
                    setWords(wordsTemporary);
                    setMaxSteps(wordsTemporary.length / 2);
                    setLevelInfo(level);
                    
                } else {
                    console.log(response.errorMess);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    
    function syncExerciseWithDB() {
        return new Promise((resolve) => {
            getLog(currentActivity).then((response) => {
                if (response.success) {
                    const exercisesString = JSON.stringify(response.data);
                    const exercises = JSON.parse(exercisesString)[0];
                    if (exercises.some((exercise) => exercise.exercise_id === exerciseId)) {
                        const exercise = exercises.find((exercise) => exercise.exercise_id === exerciseId);
                        let previousSelectedWords = [];
                        setExerciseLog(exercise);
                        exercise.actions.forEach((action) => {
                            if (action.correct) {
                                previousSelectedWords = [...action.selectedWords, ...previousSelectedWords];
                                setStepInfo(exercise.progress / 10);
                            }
                        });
                        setCorrectWords(previousSelectedWords);
                    }
                } else {
                    console.log(response.data.errorMess);
                }
                resolve();
            });
        });
    }
    
    function logUserAction(correct, progress, words) {
        const timestamp = new Date().toISOString();
        const newAction = {
            selectedWords: words,
            correct: correct,
            timestamp: timestamp,
        };
        
        setExerciseLog((prev) => ({
            ...prev,
            exercise_id: exerciseId,
            exercise_type: exerciseType,
            progress: Math.round(progress),
            actions: [...prev.actions, newAction],
        }));
    }
    
    function handleConfirmClick() {
        if(clickedWordsId.length === 2) {
            setConfirmedWords([...clickedWordsId]);
            setClickedWordsId([]);
        }
    }
    
    function handleNextExerciseClick() {
        const temp = [...activityList];
        temp.shift();
        checkActivityStatus(currentActivity, temp).then(
            (response) => {
                try {
                    setActivityList(response);
                    redirectToExercise(response, navigate);
                } catch (error) {
                    console.log(error);
                }
            }
        );
    }
    
    const handleWordClick = (word) => {
        if (clickedWordsId.some((word1) => word1.id === word.id)) {
            setClickedWordsId(clickedWordsId.filter(clickedWord => clickedWord.id !== word.id));
        } else if (clickedWordsId.length < 2) {
            setClickedWordsId((prev) => [word, ...prev]);
        }
    };
    
    useEffect(() => {
        if (correctWords.length === words.length && words.length !== 0) {
            setIsAnimating(true);
            setTimeout(() => {
                updateButtonFlow(false, true);
                setIsAnimating(false);
            }, 1250);
        } else {
            updateButtonFlow(true, false);
        }
    }, [correctWords]);
    
    useEffect(() => {
        if (confirmedWords.length < 2) return;
        setIsAnimating(true);
        
        const isCorrect = confirmedWords.every((word) => word.couple_id === confirmedWords[0].couple_id);
        const dynamicCorrectWordsCount = isCorrect ? correctWords.length + confirmedWords.length : correctWords.length;
        const progress = (dynamicCorrectWordsCount / words.length) * 100;
        logUserAction(isCorrect, progress, confirmedWords);
        
        if (isCorrect) {
            setCorrectWords((prev) => [...confirmedWords, ...prev]);
            setFeedback('happy');
            setStepInfo(stepInfo + 1);
        } else {
            setFeedback('sad');
            setErrorWords((prev) => [...confirmedWords, ...prev]);
            setTimeout(() => {
                setErrorWords([]);
                setConfirmedWords([]);
            }, 750);
        }
        setTimeout(() => {
            setFeedback('');
            setIsAnimating(false);
        }, 1250);
    }, [confirmedWords]);
    
    useEffect(() => {
        if (exerciseLog.exercise_id !== 0) {
            updateCurrentLog(currentActivity, exerciseLog).then();
        }
    }, [exerciseLog]);
    
    if(loading) {
        return (
            <div className='generalActivitiesBackground custom-col-12 tablet-custom-col-12' style={{backgroundColor: BACKGROUND_STYLE}}>
                <Spinner animation="border" variant="light"/>
            </div>
        );
    }
    
    return (
        <div className='generalActivitiesBackground custom-col-12 tablet-custom-col-12' style={{backgroundColor: BACKGROUND_STYLE}}>
            <AnimationOverlay isAnimating={isAnimating}></AnimationOverlay>
            <div className='generalActivitiesPageContent custom-col-11 tablet-custom-col-11'>
                <div className='generalActivitiesTopBarArea custom-row'>
                    <TopBar levelInfo={levelInfo} stepInfo={stepInfo} maxSteps={maxSteps}> </TopBar>
                    <Instructions hasAudio={false} instructionText={INSTRUCTION_TEXT} instructionAudioUrl={instructionAudioUrl}></Instructions>
                </div>
                <div className='generalActivitiesGameElementsArea row'>
                    <div className='generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2'>
                        <SadFeedback feedback={feedback.includes('sad')}></SadFeedback>
                    </div>
                    <div className='generalActivitiesColumnOneColumnLayout custom-col-8 tablet-custom-col-8'>
                        <div className="words-container" style={{backgroundImage: `url(${wallBackground})`}}>
                            <div className='words-grid'>
                                {words.map((word) => {
                                    let zoom = 1;
                                    let backgroundColor = '#f9f9f9';
                                    if (confirmedWords.some((confirmedWord) => confirmedWord.id === word.id)) {
                                        if (confirmedWords.every((word) => word.couple_id === confirmedWords[0].couple_id)) {
                                            backgroundColor = activity_palettes.green.tertiary;
                                        } else if (errorWords.some((errorWord) => errorWord.id === word.id)) {
                                            backgroundColor = activity_palettes.green.error_background;
                                        }
                                    } else if (clickedWordsId.some((clickedWord) => clickedWord.id === word.id)) {
                                        zoom = 1.015;
                                        backgroundColor = activity_palettes.green.secondary;
                                    }
                                    return (
                                        <WordCard
                                            key={word.id}
                                            name={word.name}
                                            backgroundColor={backgroundColor}
                                            onClick={() => handleWordClick(word)}
                                            isFlipping={correctWords.some((correctWord) => correctWord.id === word.id)}
                                            zoom={zoom}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <div className='generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2'>
                        <HappyFeedback feedback={feedback.includes('happy')}></HappyFeedback>
                    </div>
                </div>
                <div className='generalActivitiesConfirmButtonArea custom-row'>
                    {flowButtons.confirm && <ConfirmButton onClick={handleConfirmClick}/>}
                    {flowButtons.nextExercise && <NextExerciseButton onClick={handleNextExerciseClick}/>}
                </div>
            </div>
        </div>
    )
        ;
}

export default BaseDerivativeWall;
